import 'whatwg-fetch';

import { unauthorizedConfig, config, fake, get, getStream, post, put, httpDelete, postFormData } from './rest-api-calls';
import { getThunk, getStreamThunk, postThunk, putThunk, deleteThunk, shouldExecute } from './dispatch-thunk';
import { fetchActions } from './fetch-actions';
import { apiCallReducer, ApiCallState } from './fetch-reducer';

export {
  config,
  unauthorizedConfig,
  fake,
  get,
  getStream,
  post,
  put,
  httpDelete,
  postFormData,
  getThunk,
  getStreamThunk,
  postThunk,
  putThunk,
  deleteThunk,
  shouldExecute,
  fetchActions,
  apiCallReducer,
  ApiCallState,
}



// WEBPACK FOOTER //
// src/api/index.js